<template>
  <v-card>
    <Loader
      v-if="loading"
      :key="generateUniqueId()"
      :loader-state="loading"
    ></Loader>

    <v-card-title class="float-left">
      Détails d'une offre spéciale : {{ specialOffer ? specialOffer.translations.fr.name : '-' }}
    </v-card-title>

    <LocalSwitcher
      @updateCurrentLocale="updateCurrentLocale($event)"
    ></LocalSwitcher>

    <v-card-text>
      <v-form
        v-model="valid"
        class="multi-col-validation mt-5"
        @submit.prevent="checkForm"
      >
        <p v-if="errors.length">
          <v-alert
            v-for="(error, index) in errors"
            :key="index"
            text
            dense
            type="error"
          >
            {{ error.title }}
          </v-alert>
        </p>

        <Snackbar
          v-if="successMessage"
          :key="generateUniqueId()"
          :snackbar-state="snackbar"
          :success-message="successMessage"
        ></Snackbar>

        <v-row>
          <v-col
            cols="12"
            md="12"
          >
            <v-tabs
              v-model="activeTab"
              grow
            >
              <v-tab>
                <v-icon left>
                  {{ icons.mdiPencil }}
                </v-icon>
                CMS
              </v-tab>
              <v-tab>
                <v-icon left>
                  {{ icons.mdiFormatListChecks }}
                </v-icon>
                Catégories
              </v-tab>
              <v-tab>
                <v-icon left>
                  {{ icons.mdiCameraOutline }}
                </v-icon>
                Images
              </v-tab>

              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <v-row>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <h4>Description de l'offre spéciale</h4>
                        <br>
                        <v-text-field
                          v-model="name[currentLocale]"
                          label="Nom"
                          class="mb-5"
                          outlined
                          dense
                          placeholder="Nom"
                          hide-details
                        >
                          <template v-slot:append>
                            <country-flag
                              class="inner-input-flag"
                              :country="currentLocale === 'en' ? 'gb' : currentLocale"
                              size="normal"
                              shadow
                            />
                          </template>
                        </v-text-field>

                        <v-text-field
                          v-model="slug[currentLocale]"
                          label="Slug"
                          class="mb-5"
                          outlined
                          dense
                          placeholder="Slug"
                          hide-details
                        >
                          <template v-slot:append>
                            <country-flag
                              class="inner-input-flag"
                              :country="currentLocale === 'en' ? 'gb' : currentLocale"
                              size="normal"
                              shadow
                            />
                          </template>
                        </v-text-field>

                        <v-text-field
                          v-model="title[currentLocale]"
                          label="Titre"
                          class="mb-5"
                          outlined
                          dense
                          placeholder="Titre"
                          hide-details
                        >
                          <template v-slot:append>
                            <country-flag
                              class="inner-input-flag"
                              :country="currentLocale === 'en' ? 'gb' : currentLocale"
                              size="normal"
                              shadow
                            />
                          </template>
                        </v-text-field>

                        <v-text-field
                          v-model="subTitle[currentLocale]"
                          label="Sous-titre"
                          class="mb-5"
                          outlined
                          dense
                          placeholder="Sous-titre"
                          hide-details
                        >
                          <template v-slot:append>
                            <country-flag
                              class="inner-input-flag"
                              :country="currentLocale === 'en' ? 'gb' : currentLocale"
                              size="normal"
                              shadow
                            />
                          </template>
                        </v-text-field>

                        <v-text-field
                          v-model="promotion[currentLocale]"
                          label="Texte promotionnel"
                          class="mb-5"
                          outlined
                          dense
                          placeholder="Texte promotionnel"
                          hide-details
                        >
                          <template v-slot:append>
                            <country-flag
                              class="inner-input-flag"
                              :country="currentLocale === 'en' ? 'gb' : currentLocale"
                              size="normal"
                              shadow
                            />
                          </template>
                        </v-text-field>

                        <v-text-field
                          v-model="entityData.position"
                          label="Position"
                          class="mb-5"
                          outlined
                          dense
                          placeholder="Position"
                          hide-details
                        ></v-text-field>

                        <v-switch
                          v-model="entityData.enabled"
                          :label="'Etat : ' + (entityData.enabled === true ? 'Activé' : 'Désactivé')"
                        ></v-switch>

                        <v-switch
                          v-model="entityData.inMenu"
                          :label="'Dans le menu : ' + (entityData.inMenu === true ? 'Oui' : 'Non')"
                        ></v-switch>

                        <v-switch
                          v-model="entityData.onHome"
                          :label="'Sur la home : ' + (entityData.onHome === true ? 'Oui' : 'Non')"
                        ></v-switch>

                        <v-switch
                          v-model="entityData.stamped"
                          :label="'Estampiller : ' + (entityData.stamped === true ? 'Oui' : 'Non')"
                        ></v-switch>

                        <h4>SEO</h4>
                        <br>

                        <v-text-field
                          v-model="seoTitle[currentLocale]"
                          label="Titre SEO"
                          class="mb-5"
                          outlined
                          dense
                          placeholder="Titre SEO"
                          hide-details
                        >
                          <template v-slot:append>
                            <country-flag
                              class="inner-input-flag"
                              :country="currentLocale === 'en' ? 'gb' : currentLocale"
                              size="normal"
                              shadow
                            />
                          </template>
                        </v-text-field>

                        <v-text-field
                          v-model="seoDescription[currentLocale]"
                          label="Description SEO"
                          class="mb-5"
                          outlined
                          dense
                          placeholder="Description SEO"
                          hide-details
                        >
                          <template v-slot:append>
                            <country-flag
                              class="inner-input-flag"
                              :country="currentLocale === 'en' ? 'gb' : currentLocale"
                              size="normal"
                              shadow
                            />
                          </template>
                        </v-text-field>

                        <v-text-field
                          v-model="seoKeywords[currentLocale]"
                          label="Mot clés"
                          class="mb-5"
                          outlined
                          dense
                          placeholder="Mot clés"
                          hide-details
                        >
                          <template v-slot:append>
                            <country-flag
                              class="inner-input-flag"
                              :country="currentLocale === 'en' ? 'gb' : currentLocale"
                              size="normal"
                              shadow
                            />
                          </template>
                        </v-text-field>

                        <v-divider class="v-divider-entity mt-5 mb-5"></v-divider>

                        <v-row>
                          <v-col
                            cols="12"
                            sm="6"
                          >
                            <h4 class="mb-4">
                              Date de début
                            </h4>
                            <VDatePicker
                              v-model="entityData.startDate"
                              class="special-offer-date-picker"
                              label="Date de début"
                              full-width
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            sm="6"
                          >
                            <h4 class="mb-4">
                              Date de fin
                            </h4>
                            <VDatePicker
                              v-model="entityData.endDate"
                              class="special-offer-date-picker"
                              label="Date de fin"
                              full-width
                            />
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <div class="content-ckeditor-region">
                          <h4>Description</h4>
                          <br>
                          <ckeditor
                            v-model="description[currentLocale]"
                            :editor="editor"
                            :config="editorConfig"
                            height="10"
                            row="50"
                          />
                          <country-flag
                            class="inner-input-flag content-flag-placeholder"
                            :country="currentLocale === 'en' ? 'gb' : currentLocale"
                            size="normal"
                            shadow
                          />
                        </div>

                        <br>

                        <div class="content-ckeditor-region">
                          <h4>Description bas de page</h4>
                          <br>
                          <ckeditor
                            v-model="bottomDescription[currentLocale]"
                            :editor="editor"
                            :config="editorConfig"
                            height="10"
                            row="50"
                          />
                          <country-flag
                            class="inner-input-flag content-flag-placeholder"
                            :country="currentLocale === 'en' ? 'gb' : currentLocale"
                            size="normal"
                            shadow
                          />
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <CategorySelector
                      v-if="entityLoaded"
                      v-model="categorySelection"
                      :super-category-id="entityData.id"
                      :disabled="loading"
                      :refresh="categoryRefresh"
                    />
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <ImageHandler
                      :key="generateUniqueId()"
                      :entity-data="entityData"
                      image-label="Photo principale"
                      image-name="mainImage"
                      :icons="icons"
                      :valid="valid"
                      :loading="loading"
                      :success-message="successMessage"
                      :snackbar="snackbar"
                      @update="updateEntityData($event)"
                    ></ImageHandler>

                    <br>

                    <v-divider class="v-divider-entity mt-5 mb-5"></v-divider>

                    <ImageHandler
                      :key="generateUniqueId()"
                      :entity-data="entityData"
                      image-label="Photo mobile"
                      image-name="mobileImage"
                      :icons="icons"
                      :valid="valid"
                      :loading="loading"
                      :success-message="successMessage"
                      :snackbar="snackbar"
                      @update="updateEntityData($event)"
                    ></ImageHandler>

                    <br>

                    <v-divider class="v-divider-entity mt-5 mb-5"></v-divider>

                    <ImageHandler
                      :key="generateUniqueId()"
                      :entity-data="entityData"
                      image-label="Photo page d'accueil"
                      image-name="homeImage"
                      :icons="icons"
                      :valid="valid"
                      :loading="loading"
                      :success-message="successMessage"
                      :snackbar="snackbar"
                      @update="updateEntityData($event)"
                    ></ImageHandler>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-btn
              class="mt-5 mr-2"
              color="primary"
              :disabled="!entityLoaded || !valid || loading"
              type="submit"
            >
              Valider
            </v-btn>

            <v-btn
              class="mt-5"
              text
              :to="{ name: 'specialOfferList' }"
            >
              Retour
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import Vue from 'vue'
import { mdiEyeOutline, mdiEyeOffOutline, mdiCameraOutline, mdiMinusBox, mdiPencil, mdiCompassRose, mdiThumbUp, mdiSkiWater, mdiFormatListChecks } from '@mdi/js'
import config from '../../../config'
import LocalSwitcher from '@/components/Common/LocalSwitcher.vue'
import Snackbar from '@/components/Common/Snackbar.vue'
import Loader from '@/components/Common/Loader.vue'
import ImageHandler from '@/components/Common/ImageHandler.vue'
import CategorySelector from '@/components/SpecialOffer/CategorySelector.vue'
import CKEditor from '@ckeditor/ckeditor5-vue2'
import FullEditor from 'ckeditor5-custom-build'

export default {
  components: {
    CategorySelector,
    ImageHandler,
    Snackbar,
    LocalSwitcher,
    Loader,
    ckeditor: CKEditor.component
  },
  data () {
    return {
      valid: false,
      activeTab: this.$route.query.tab === 'images' ? 2 : 0,
      errors: [],
      snackbar: false,
      successMessage: null,
      loading: false,
      currentLocale: 'fr',
      icons: {
        mdiFormatListChecks,
        mdiEyeOutline,
        mdiEyeOffOutline,
        mdiCameraOutline,
        mdiMinusBox,
        mdiPencil,
        mdiCompassRose,
        mdiSkiWater,
        mdiThumbUp
      },
      editor: FullEditor,
      editorConfig: {
        toolbar: {
          shouldNotGroupWhenFull: true
        },
        heading: {
          options: [
            { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
            { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
            { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
            { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
            { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
            { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
            { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' }
          ]
        },
        htmlSupport: {
          allow: [
            {
              name: /.*/,
              attributes: true,
              classes: true,
              styles: true
            }
          ]
        },
        simpleUpload: {
          uploadUrl: config.apiUrl + '/api/medias',
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.getToken
          }
        }
      },
      entityLoaded: false,
      categoryRefresh: 0,
      categorySelection: [],
      id: [],
      name: [],
      slug: [],
      title: [],
      subTitle: [],
      description: [],
      bottomDescription: [],
      seoTitle: [],
      seoDescription: [],
      seoKeywords: [],
      txtZone1: [],
      txtZone2: [],
      promotion: [],
      specialOffer: null,
      entityData: {
        id: null,
        enabled: null,
        inMenu: true,
        onHome: false,
        stamped: false,
        startDate: null,
        endDate: null,
        currentLocale: 'fr',
        defaultLocale: 'fr',
        newTranslations: {},
        mainImage: {
          id: null,
          title: null
        },
        mobileImage: {
          id: null,
          title: null
        },
        homeImage: {
          id: null,
          title: null
        }
      }
    }
  },
  created () {
    this.getSpecialOffer()
  },
  methods: {
    checkForm () {
      this.errors = []

      if (this.entityLoaded && this.valid && !this.loading) {
        this.putSpecialOffer()
      }
    },
    apiUrl () {
      return config.apiUrl
    },
    getSpecialOffer () {
      const specialOfferId = this.$route.params.specialOfferId

      this.loading = true

      Vue.prototype.$http
        .get(config.apiUrl + '/api/special-offer/super-categories/' + specialOfferId, {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.getToken
          }
        })
        .then(response => {
          if (response.status === 200) {
            if (!Array.isArray(response.data.specialOfferCategories)
              || response.data.specialOfferCategories.some(category => !category || typeof category.id !== 'string')) {
              throw new Error('Invalid category associations')
            }
            this.specialOffer = response.data
            this.entityData.id = this.specialOffer.id
            this.entityData.enabled = this.specialOffer.enabled
            this.entityData.inMenu = this.specialOffer.inMenu
            this.entityData.onHome = this.specialOffer.onHome === true
            this.entityData.stamped = this.specialOffer.stamped
            this.entityData.position = this.specialOffer.position

            if (this.specialOffer.mainImage) {
              this.entityData.mainImage = this.specialOffer.mainImage
            }

            if (this.specialOffer.mobileImage) {
              this.entityData.mobileImage = this.specialOffer.mobileImage
            }

            if (this.specialOffer.homeImage) {
              this.entityData.homeImage = this.specialOffer.homeImage
            }

            if (this.specialOffer.startDate) {
              this.entityData.startDate = this.specialOffer.startDate.split("T")[0]
            }

            if (this.specialOffer.endDate) {
              this.entityData.endDate = this.specialOffer.endDate.split("T")[0]
            }

            this.entityData.specialOfferCategories = this.specialOffer.specialOfferCategories

            this.categorySelection = this.entityData.specialOfferCategories.map(category => category.id)

            const translations = this.specialOffer.translations

            for (const [currentKey] of Object.entries(translations)) {
              let currentTranslation = translations[currentKey]

              this.id[currentKey] = currentTranslation.id
              this.name[currentKey] = currentTranslation.name
              this.slug[currentKey] = currentTranslation.slug
              this.title[currentKey] = currentTranslation.title
              this.subTitle[currentKey] = currentTranslation.subTitle
              this.description[currentKey] = currentTranslation.description
              this.bottomDescription[currentKey] = currentTranslation.bottomDescription
              this.seoTitle[currentKey] = currentTranslation.seoTitle
              this.seoDescription[currentKey] = currentTranslation.seoDescription
              this.seoKeywords[currentKey] = currentTranslation.seoKeywords
              this.txtZone1[currentKey] = currentTranslation.txtZone1
              this.txtZone2[currentKey] = currentTranslation.txtZone2
              this.promotion[currentKey] = currentTranslation.promotion
            }

            this.entityLoaded = true
            this.valid = true
          }

          this.loading = false
        })
        .catch(() => {
          this.errors = [{ title: 'Impossible de charger la super-catégorie et ses associations. Rechargez la page avant de modifier.' }]
          this.loading = false
        })
    },
    putSpecialOffer () {
      this.loading = true
      this.valid = false
      this.successMessage = null

      this.handleTranslations([
        'id',
        'name',
        'slug',
        'title',
        'subTitle',
        'description',
        'bottomDescription',
        'seoTitle',
        'seoDescription',
        'seoKeywords',
        'txtZone1',
        'txtZone2',
        'promotion'
      ])

      const selectedCategories = []

      for (let i = 0; i < this.categorySelection.length; i++) {
        const currentCategory = this.categorySelection[i]

        selectedCategories.push({
          id: (typeof currentCategory === 'string') ? currentCategory : currentCategory.value
        })
      }

      this.entityData.specialOfferCategories = selectedCategories

      Vue.prototype.$http
        .put(config.apiUrl + '/api/special-offer/super-categories/' + this.entityData.id, this.entityData, {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.getToken
          }
        })
        .then(response => {
          if (response.status === 200) {
            this.specialOffer = response.data
            ++this.categoryRefresh

            const translations = this.specialOffer.translations

            for (const [currentKey] of Object.entries(translations)) {
              let currentTranslation = translations[currentKey]

              this.id[currentKey] = currentTranslation.id
              this.name[currentKey] = currentTranslation.name
              this.slug[currentKey] = currentTranslation.slug
              this.title[currentKey] = currentTranslation.title
              this.subTitle[currentKey] = currentTranslation.subTitle
              this.description[currentKey] = currentTranslation.description
              this.bottomDescription[currentKey] = currentTranslation.bottomDescription
              this.seoTitle[currentKey] = currentTranslation.seoTitle
              this.seoDescription[currentKey] = currentTranslation.seoDescription
              this.seoKeywords[currentKey] = currentTranslation.seoKeywords
              this.txtZone1[currentKey] = currentTranslation.txtZone1
              this.txtZone2[currentKey] = currentTranslation.txtZone2
              this.promotion[currentKey] = currentTranslation.promotion
            }

            this.snackbar = true
            this.successMessage = 'Offre spéciale mise à jour avec succès.'
            this.valid = true
          }

          this.loading = false
        })
        .catch(e => {
          const response = e.response

          this.successMessage = null

          if (response.status === 400 || response.status === 404) {
            const data = response.data
            this.errors = data.violations
          }

          this.valid = true
          this.loading = false
        })
    },
    handleTranslations (attributes) {
      for (let i = 0; i < attributes.length; i++) {
        const currentAttribute = attributes[i]

        for (const [currentKey, currentValue] of Object.entries(this[currentAttribute])) {
          let translation = {
            locale: currentKey,
            empty: false
          }

          translation[currentAttribute] = currentValue

          const currentObjState = this.entityData.newTranslations[currentKey]

          this.entityData.newTranslations[currentKey] = {...currentObjState, ...translation}
        }
      }
    },
    updateCurrentLocale (locale) {
      this.currentLocale = locale
      this.successMessage = null
    },
    updateEntityData (updatedData) {
      this.entityData = updatedData
    },
    updateLoading (loading) {
      this.loading = loading
    },
    updateSnackbar (snackbar) {
      this.snackbar = snackbar
    },
    updateSuccessMessage (successMessage) {
      this.successMessage = successMessage
    },
    updateValid (valid) {
      this.valid = valid
    }
  }
}
</script>

<style scoped>
.special-offer-date-picker {
  max-width: 290px;
}
</style>
